import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const RolesLayout = lazy(() => import('@/pages/roles/layout'));
const RoleLayout = lazy(() => import('@/pages/roles/[roleId]/layout'));

// Lazy load role pages
const RolesPage = lazy(() => import('@/pages/roles'));
const RolesHistoryPage = lazy(() => import('@/pages/roles/history'));
const CreateRolePage = lazy(() => import('@/pages/roles/create'));
const UpdateRolePage = lazy(() => import('@/pages/roles/[roleId]/update'));

/**
 * Role routes
 * Handles role management
 */
export const roleRoutes: RouteConfig = {
  path: '/roles',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: RolesLayout,
      children: [
        {
          path: '',
          element: RolesPage,
        },
        {
          path: '/history',
          element: RolesHistoryPage,
        },
        {
          path: '/create',
          element: CreateRolePage,
        },
      ],
    },
    {
      path: '/:roleId',
      layout: RoleLayout,
      children: [
        {
          path: '/update',
          element: UpdateRolePage,
        },
      ],
    },
  ],
};
